import { FC, useMemo } from 'react'
import Image from 'next/image'

import Property from 'components/parts/property/property'
import Button from 'components/parts/button/button'

import { ICourseType } from 'constants/types/course.types'
import { STATIC_PREVIEW_URL, currImageDomain, STATIC_URL } from 'constants/data'
import { getMedcoinsFromNmoPoints } from './utils'

import styles from './course-card.module.scss'

const coinsIcon = (
  <Image src={`${STATIC_URL}/game/coin.svg`} alt={'Медкоин'} width={16} height={16} />
)

const CourseCard: FC<ICourseType> = ({
  name,
  points,
  available,
  previewName,
  Specialities,
  btnName = 'Посмотреть программу',
}) => {
  const specialitiesList = Specialities && Specialities.join(', ')

  const capitalizedName = useMemo(() => {
    return name.charAt(0).toUpperCase() + name.slice(1)
  }, [name])

  const medcoinsValue = getMedcoinsFromNmoPoints(points)

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.cardContent}>
        <div className={styles.propertiesBlock}>
          <div className={styles.properties}>
            <Property
              text={`${points} НМО`}
              modificator={styles.yellowProperty}
              wrapperModificator={styles.cardProperty}
            />
            <Property
              text="Видеолекции"
              modificator={styles.greyProperty}
              wrapperModificator={styles.cardProperty}
            />
            <Property
              text={medcoinsValue}
              modificator={styles.blueProperty}
              wrapperModificator={styles.cardProperty}
              icon={coinsIcon}
            />
          </div>
        </div>
        <div className={styles.cardTop}>
          <p className={styles.courseName}>{capitalizedName}</p>
          {specialitiesList}
        </div>
        <div className={styles.cardImg}>
          {previewName ? (
            <img
              src={`${currImageDomain}${STATIC_PREVIEW_URL}/courseAvatar/${previewName}`}
              alt={capitalizedName}
            />
          ) : (
            <div />
          )}
        </div>
        <div className={styles.cardBottom}>
          {available && <span className={styles.purchased}>Вы приобрели этот курс 😊</span>}
          {!available && (
            <div className={styles.actionBlock}>
              <Button>{btnName}</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CourseCard
